import { Box, Grid } from "@mui/material";
import { useHookFormContext } from "../../../../utils/hooks/useHookFormContext";
import { HookTextField } from "../../../../atoms/form-fields/SLFieldTextField";
import FormCancelSubmitBtns from "../../../../atoms/formCancelSubmitBtns";
import { commonInputStyles } from "../../project-call-log-form/style";
import CustomBtnFilled from "../../../../atoms/form-molecules/CustomBtnFilled";

const Fields = () => {
    const { registerState } = useHookFormContext();
    return (
        <Box padding={"12px 20px"} display="flex" alignItems="start" gap={1} >
            <HookTextField
                {...registerState("enter_email")}
                rules={{
                    required: { value: true, message: "This field is required" },
                    pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@infollion\.com$/,
                    message: "Email must end with @infollion.com",
                    },
                }}
                textFieldProps={{
                    ...commonInputStyles,
                    label: "Enter Email",
                    required: true,
                }}
            />
            <Box padding={"2px 0px"} display="flex" alignItems="center" >
                <CustomBtnFilled
                    styles={{height: "30px", fontSize: '15px',fontWeight: 300, fontFamily: 'Montserrat'}}
                    label={'add'}
                    variant="contained"
                    buttonType="submit"
                />
            </Box>
        </Box>
    )
}

export default Fields